(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('FirebaseConfig', FirebaseConfig);

    FirebaseConfig.$inject = ['FIREBASE_CONFIG'];

    function FirebaseConfig(FIREBASE_CONFIG) {
        // Initialize Firebase
        if (!firebase.apps.length) {
            firebase.initializeApp(FIREBASE_CONFIG);
        }

        return firebase;
    }
})();
